/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Disp_PropertiesInputs */

const en_disp_properties = /** @type {(inputs: Disp_PropertiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Properties`)
};

const de_disp_properties = /** @type {(inputs: Disp_PropertiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eigenschaften`)
};

/**
* | output |
* | --- |
* | "Properties" |
*
* @param {Disp_PropertiesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const disp_properties = /** @type {((inputs?: Disp_PropertiesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Disp_PropertiesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_disp_properties(inputs)
	return en_disp_properties(inputs)
});